// Redux/constants/receptionistConstants.js

// Lookup patient
export const LOOKUP_PATIENT_REQUEST = "LOOKUP_PATIENT_REQUEST";
export const LOOKUP_PATIENT_SUCCESS = "LOOKUP_PATIENT_SUCCESS";
export const LOOKUP_PATIENT_FAIL = "LOOKUP_PATIENT_FAIL";
export const LOOKUP_PATIENT_RESET = "LOOKUP_PATIENT_RESET";

// Create walk-in appointment
export const CREATE_WALKIN_REQUEST = "CREATE_WALKIN_REQUEST";
export const CREATE_WALKIN_SUCCESS = "CREATE_WALKIN_SUCCESS";
export const CREATE_WALKIN_FAIL = "CREATE_WALKIN_FAIL";

// Fetch departments
export const FETCH_DEPARTMENTS_REQUEST = "FETCH_DEPARTMENTS_REQUEST";
export const FETCH_DEPARTMENTS_SUCCESS = "FETCH_DEPARTMENTS_SUCCESS";
export const FETCH_DEPARTMENTS_FAIL = "FETCH_DEPARTMENTS_FAIL";

// Fetch doctors by department
export const FETCH_DOCTORS_BY_DEPT_REQUEST = "FETCH_DOCTORS_BY_DEPT_REQUEST";
export const FETCH_DOCTORS_BY_DEPT_SUCCESS = "FETCH_DOCTORS_BY_DEPT_SUCCESS";
export const FETCH_DOCTORS_BY_DEPT_FAIL = "FETCH_DOCTORS_BY_DEPT_FAIL";

// Fetch appointments
export const FETCH_APPOINTMENTS_REQUEST = "FETCH_APPOINTMENTS_REQUEST";
export const FETCH_APPOINTMENTS_SUCCESS = "FETCH_APPOINTMENTS_SUCCESS";
export const FETCH_APPOINTMENTS_FAIL = "FETCH_APPOINTMENTS_FAIL";

// Assign appointment
export const ASSIGN_APPOINTMENT_REQUEST = "ASSIGN_APPOINTMENT_REQUEST";
export const ASSIGN_APPOINTMENT_SUCCESS = "ASSIGN_APPOINTMENT_SUCCESS";
export const ASSIGN_APPOINTMENT_FAIL = "ASSIGN_APPOINTMENT_FAIL";

// Reject appointment
export const REJECT_APPOINTMENT_REQUEST = "REJECT_APPOINTMENT_REQUEST";
export const REJECT_APPOINTMENT_SUCCESS = "REJECT_APPOINTMENT_SUCCESS";
export const REJECT_APPOINTMENT_FAIL = "REJECT_APPOINTMENT_FAIL";

// Complete appointment
export const COMPLETE_APPOINTMENT_REQUEST = "COMPLETE_APPOINTMENT_REQUEST";
export const COMPLETE_APPOINTMENT_SUCCESS = "COMPLETE_APPOINTMENT_SUCCESS";
export const COMPLETE_APPOINTMENT_FAIL = "COMPLETE_APPOINTMENT_FAIL";

// Print payment receipt
export const PRINT_PAYMENT_RECEIPT_REQUEST = "PRINT_PAYMENT_RECEIPT_REQUEST";
export const PRINT_PAYMENT_RECEIPT_SUCCESS = "PRINT_PAYMENT_RECEIPT_SUCCESS";
export const PRINT_PAYMENT_RECEIPT_FAIL = "PRINT_PAYMENT_RECEIPT_FAIL";

// MEDICINE Search
export const MEDICINES_SEARCH_REQUEST = "MEDICINES_SEARCH_REQUEST";
export const MEDICINES_SEARCH_SUCCESS = "MEDICINES_SEARCH_SUCCESS";
export const MEDICINES_SEARCH_FAIL = "MEDICINES_SEARCH_FAIL";

export const SEARCH_PATIENTS_REQUEST = "SEARCH_PATIENTS_REQUEST";
export const SEARCH_PATIENTS_SUCCESS = "SEARCH_PATIENTS_SUCCESS";
export const SEARCH_PATIENTS_FAIL = "SEARCH_PATIENTS_FAIL";